module.exports = __webpack_public_path__ + "img/003-house.67cea8c5.svg";